import TangerineAIChatbot from './TangerineAIChatbot';

export default TangerineAIChatbot;